import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import debug from '@/store/modules/debug';
import member from './modules/member';
import auth from './modules/auth';
import customization from '@/store/modules/customization';
import estimate from './modules/estimate';
import hccs from './modules/hccs';
import idle from './modules/idle';
import lookup from './modules/lookup';
import otp from './modules/otp';
import options from './modules/options';
import policy from './modules/policy';
import renewPolicy from '@/store/modules/renewPolicy';
import trade from '@/store/modules/trade';
import ins01 from './modules/insurances/01';
import ins02 from './modules/insurances/02';
import ins05 from './modules/insurances/05';
import ins07 from './modules/insurances/07';
import ins09 from './modules/insurances/09';
import ins10 from './modules/insurances/10';
import ins201 from './modules/insurances/201';
import ins205 from './modules/insurances/205';
import ins209 from './modules/insurances/209';
import ins176 from './modules/insurances/176';
import ins177 from './modules/insurances/177';
import ins11 from './modules/insurances/11';
import ins211 from './modules/insurances/211';
import ins15 from './modules/insurances/15';
import ins12 from './modules/insurances/12';
import ins17 from './modules/insurances/17';
import ins19 from './modules/insurances/19';
import ins21 from './modules/insurances/21';
import ins28 from './modules/insurances/28';
import ins31 from './modules/insurances/31';
import ins32 from './modules/insurances/32';
import ins231 from './modules/insurances/231';
import ins232 from './modules/insurances/232';
import ins34 from './modules/insurances/34';
import ins62 from './modules/insurances/62';
import ins63 from './modules/insurances/63';
import ins64 from './modules/insurances/64';
import ins55 from './modules/insurances/55';
import ins301 from './modules/insurances/301';
import ins109 from './modules/insurances/109';
import ins27 from './modules/insurances/27';
import ins164 from './modules/insurances/164';
import ins165 from './modules/insurances/165';
import ins29 from './modules/insurances/29';
import ins30 from './modules/insurances/30';
import ins56 from './modules/insurances/56';
import ins161 from './modules/insurances/161';
import ins166 from './modules/insurances/166';
import ins198 from './modules/insurances/198';
import ins237 from './modules/insurances/237';
import ins238 from './modules/insurances/238';
import ins178 from './modules/insurances/178';
import ins110 from './modules/insurances/110';
import ins111 from './modules/insurances/111';
import ins113 from './modules/insurances/113';
import ins114 from './modules/insurances/114';
import ins115 from './modules/insurances/115';
import ins117 from './modules/insurances/117';
import ins47 from './modules/insurances/47';
import ins147 from './modules/insurances/147';
import router from '@/store/modules/router';
import esunwallet from './modules/esunwallet';
// 不存入 session storage
import input from '@/store/modules/input';
import terms from '@/store/modules/terms';
import renewal from '@/store/modules/renewal';
import nav from '@/store/modules/nav';

const sessionStorageState = createPersistedState({
    paths: [
        'debug',
        'member',
        'auth',
        'estimate',
        'hccs',
        'idle',
        'lookup',
        'otp',
        'options',
        'policy',
        'renewPolicy',
        'trade',
        'ins01',
        'ins02',
        'ins05',
        'ins07',
        'ins09',
        'ins10',
        'ins201',
        'ins205',
        'ins209',
        'ins176',
        'ins177',
        'ins11',
        'ins211',
        'ins12',
        'ins15',
        'ins17',
        'ins19',
        'ins21',
        'ins28',
        'ins31',
        'ins32',
        'ins231',
        'ins232',
        'ins62',
        'ins63',
        'ins64',
        'ins301',
        'ins109',
        'ins55',
        'ins34',
        'ins27',
        'ins161',
        'ins164',
        'ins165',
        'ins29',
        'ins30',
        'ins56',
        'ins166',
        'ins198',
        'ins237',
        'ins238',
        'ins178',
        'ins110',
        'ins111',
        'ins113',
        'ins114',
        'ins115',
        'ins117',
        'ins110',
        'ins47',
        'ins147',
        'router',
        'esunwallet'
    ],
    // reducer(val) {
    //     return {
    //         estimateId: val.estimateId
    //     };
    // },
    storage: window.sessionStorage
});

/**
 * 建立一個 Vuex 的 Store 
 */
export const store = createStore({
    state: {
        allowLeavePage: true,
        isInsuresAndCoversLoaded: false, // 保險內容選項是否已下載
        navigationDrawer: {
            isActive: false
        },
        loading: true,
        header: true,
        showSubmenu: false, // header 的"更多"按鈕下拉選單
        showTimeoutAlert: false,
        leavePageAlert: false, // 顯示“離開頁面警示” dialog
        // 基本 popup 一次性提示視窗(只顯示於當頁、非跳轉頁面、非獨立頁面，只有關閉功能)
        dialog: {
            active: false,
            title: '系統提示',
            showCloseButton: false,
            type: 'warning',
            text: '系統忙碌中，請稍後再試',
            confirmButtonText: '確認',
            closeFunc: () => {
                this.state.dialog.active = false;
            }
        },
        insCategory: '', // Car Motorcycle
    },
    mutations: {
        /**
         * 設定頁面insCategory car/motor
         * 
         * @param {*} state 
         * @param {*} payload 
         */
        setInsCategory(state, payload) {
            state.insCategory = payload;
        },
        /**
         * 設定離開頁面
         * 
         * @param {*} state 
         * @param {*} payload 
         */
        setAllowLeavePage(state, payload) {
            state.allowLeavePage = payload;
        },
        /**
         * 設定 header menu 的開關
         * 
         * @param {*} state 
         */
        navigationDrawerToggle(state) {
            state.navigationDrawer.isActive = !state.navigationDrawer.isActive;
        },
        /**
         * 關閉 header 的 menu
         * 
         * @param {*} state 
         */
        navigationDrawerClose(state) {
            state.navigationDrawer.isActive = false;
        },
        /**
         * 顯示 loading 畫面
         * 
         * @param {*} state 
         */
        showLoading(state) {
            state.loading = true;
        },
        /**
         * 關閉 loading 畫面
         * 
         * @param {*} state 
         */
        closeLoading(state) {
            state.loading = false;
        },
        /**
         * 保險內容已下載
         * 
         * @param {*} state 
         */
        insuresAndCoversLoaded(state) {
            state.isInsuresAndCoversLoaded = true;
        },
        /**
         * 要顯示 header
         * 
         * @param {*} state 
         */
        showHeader(state) {
            state.header = true;
        },
        /**
         * 不顯示 header
         * 
         * @param {*} state 
         */
        hideHeader(state) {
            state.header = false;
        },
        /**
         * 關閉"保單服務"和"漢堡"的選項
         * 
         * @param {*} state 
         */
        hideAllSubmenu(state) {
            state.showSubmenu = false;
        },
        /**
         * 關閉漢堡選單
         * 
         * @param {*} state 
         */
        hideSubmenu(state) {
            state.showSubmenu = false;
        },
        /**
         * 開啟或關閉漢堡選單
         * 
         * @param {*} state 
         */
        toggleSubmenu(state) {
            state.showSubmenu = !state.showSubmenu;
        },
        /**
         * 沒有被選取的險種
         * 
         * @param {*} state 
         */
        unselectInsurances(state) {
            const insurances = state.policy.allInsurances;

            for (let i = 0; i < insurances.length; i++) {
                if (state['ins' + insurances[i]]) state['ins' + insurances[i]].selected = false;
            }
        },
        /**
         * 顯示超時登出提醒
         * 
         * @param {*} state 
         */
        setTimeout(state) {
            state.showTimeoutAlert = true;
        },
        /**
         * 關閉超時登出提醒
         * 
         * @param {*} state 
         */
        clearTimeout(state) {
            state.showTimeoutAlert = false;
        },
        /**
         * 提示訊息的設定
         * 
         * @param {*} state 
         * @param {*} payload 
         */
        setDialog(state, payload) {
            state.dialog.active = payload.active || false;
            state.dialog.text = payload.text || '系統忙碌中，請稍後再試';
            state.dialog.title = payload.title || '系統提示';
            state.dialog.type = payload.type || 'warning';
            state.dialog.confirmButtonText = '確認';
            state.dialog.showCloseButton = payload.showCloseButton || false;
            if (payload.closeFunc) {
                state.dialog.closeFunc = payload.closeFunc;
            } else {
                state.dialog.closeFunc = () => {
                    state.dialog.active = false;
                };
            }
        },
        /**
         * 提示訊息的設定
         * 
         * @param {*} state 
         */
        clearDialog(state) {
            state.dialog.active = false;
            state.dialog.text = '系統忙碌中，請稍後再試';
            state.dialog.title = '系統提示';
            state.dialog.type = 'warning';
            state.dialog.confirmButtonText = '確認';
            state.dialog.showCloseButton = false;
            state.dialog.closeFunc = () => {
                state.dialog.active = false;
            };
        },
        /**
         * 顯示離開頁面的警示
         * 
         * @param {*} state 
         */
        showLeavePageAlert(state) {
            state.leavePageAlert = true;
        },
        /**
         * 關閉離開頁面的警示
         * 
         * @param {*} state 
         */
        closeLeavePageAlert(state) {
            state.leavePageAlert = false;
        }
    },
    actions: {
        // 取消所有險種的選擇，並狀各險種選項初始化
        setAllInsurancesDefault(context) {

            const insurances = context.state.policy.allInsurances;

            for (let i = 0; i < insurances.length; i++) {
                if (context.state['ins' + insurances[i]]) {
                    context.commit('ins' + insurances[i] + '/select', false);
                    context.dispatch('ins' + insurances[i] + '/clearUserData');
                }
            }
            context.commit('policy/setInsuresAndCoversLoaded', false);
        },
        /**
         * 清空試算過的險種選項資料
         * 
         * @param {*} context 
         * @returns 
         */
        clearValidData(context) {
            return new Promise((resolve) => {
                const insurances = context.state.policy.allInsurances;
                for (let i = 0; i < insurances.length; i++) {
                    if (context.state['ins' + insurances[i]]) {
                        context.commit('ins' + insurances[i] + '/clearValidData');
                    }
                }
                resolve();
            });
        },
        /**
         * 儲存選擇之險種進 store
         * @param dispatch
         * @param state
         * @param insurances
         */
        setPolicyInsures({dispatch, state}, insurances) {
            dispatch('setAllInsurancesDefault').then(() => {
                _.forEach(insurances, o => {
                    state['ins' + o.InsType].uploadForm.InjuredCover = o.InjuredCover;
                    state['ins' + o.InsType].uploadForm.DeathCover = o.DeathCover;
                    state['ins' + o.InsType].uploadForm.DamageCover = o.DamageCover;
                    state['ins' + o.InsType].uploadForm.Deduct = o.Deduct;
                    state['ins' + o.InsType].uploadForm.QDay = o.QDay;
                    state['ins' + o.InsType].uploadForm.Provision = o.Provision;
                    state['ins' + o.InsType].uploadForm.InsScope = o.InsScope;
                    state['ins' + o.InsType].uploadForm.RemedyDailyPay = o.RemedyDailyPay;
                    state['ins' + o.InsType].selected = true;
                });
            });
        },
        /**
         * 清除所有 storage (不含登入狀態)
         * @param context
         * @returns {Promise}
         */
        reset(context) {
            return new Promise((resolve) => {
                context.commit('policy/clear');
                context.commit('estimate/clear');
                context.commit('hccs/clear');
                context.commit('trade/clear');
                context.commit('renewPolicy/clear');
                context.commit('input/clear');
                context.commit('lookup/clear');
                context.commit('ins56/setPas', null);
                context.commit('ins166/setPas', null);
                context.commit('policy/setProvs', null);
                context.commit('terms/setAllUnread');
                context.dispatch('setAllInsurancesDefault').then(() => {
                    resolve();
                });
            });
        }
    },
    modules: {
        debug,
        member,
        auth,
        estimate,
        hccs,
        idle,
        lookup,
        otp,
        options,
        policy,
        renewPolicy,
        terms,
        trade,
        ins01,
        ins02,
        ins05,
        ins07,
        ins09,
        ins10,
        ins201,
        ins205,
        ins209,
        ins176,
        ins177,
        ins11,
        ins211,
        ins12,
        ins15,
        ins17,
        ins19,
        ins21,
        ins28,
        ins31,
        ins32,
        ins231,
        ins232,
        ins62,
        ins63,
        ins64,
        ins301,
        ins109,
        ins55,
        ins34,
        ins27,
        ins161,
        ins164,
        ins165,
        ins29,
        ins30,
        ins56,
        ins166,
        ins198,
        ins237,
        ins238,
        ins178,
        ins110,
        ins111,
        ins113,
        ins114,
        ins115,
        ins117,
        ins47,
        ins147,
        input,
        customization,
        renewal,
        nav,
        router,
        esunwallet
    },
    plugins: [sessionStorageState]
});